import React from 'react'
import StatusItem from './StatusItem'
import s from '../../css/status/status.module.css'
import Loader from '../Loader'

const Status = ({ statusData }) => {
	if (!statusData) return <Loader />

	const list = statusData.endpoints
	const failedCount = list.filter(item => item.status !== 200).length
	const isAllOk = failedCount === 0

	return (
		<div className={s.container}>
			<div className='common__body'>
				<div className={`${s.summary} ${isAllOk ? s.summaryOk : s.summaryErr}`}>
					<span className={s.summaryDot} />
					<span className={s.summaryText}>
						{isAllOk
							? 'Все системы работают'
							: `Проблемы с ${failedCount} из ${list.length} маршрутов`}
					</span>
				</div>
				<div className={s.title}>
					<span>Маршрут</span>
					<span>Задержка</span>
					<span>Статус</span>
				</div>
				<ul>
					{list.map((item, i) => (
						<StatusItem
							key={i}
							endpoint={item.endpoint}
							status={item.status}
							latencyMs={item.latencyMs}
						/>
					))}
				</ul>
			</div>
		</div>
	)
}

export default Status
